export function mapUsersToRows(users = []) {
  return users.map((user) => ({
    ...user,
    id: user.user_id,
    actions: {
      email: user?.email,
      userType: user?.user_type,
    },
  }));
}

export function filterUsersBySearch(users = [], searchText = "") {
  const normalizedSearch = `${searchText || ""}`.trim().toLowerCase();

  if (!normalizedSearch) {
    return users;
  }

  return users.filter((user) => {
    const firstName = `${user?.first_name || ""}`.trim().toLowerCase();
    const lastName = `${user?.last_name || ""}`.trim().toLowerCase();
    const fullName = `${firstName} ${lastName}`.trim();
    const compactFullName = fullName.replace(/\s+/g, "");
    const searchableValues = [
      firstName,
      lastName,
      fullName,
      compactFullName,
    ];

    return searchableValues.some((value) => value.includes(normalizedSearch));
  });
}

export function filterUsersByStatus(users = [], userStatus) {
  if (!userStatus || userStatus === "all") {
    return users;
  }

  if (userStatus === "active") {
    return users.filter((user) => user.active);
  }

  if (userStatus === "inactive") {
    return users.filter((user) => !user.active);
  }

  return users;
}

export function filterUsersByType(users = [], userType) {
  if (!userType || userType === "all") {
    return users;
  }

  if (userType === "internal") {
    return users.filter((user) => user.user_type === "Internal");
  }

  if (userType === "external") {
    return users.filter((user) => user.user_type === "External");
  }

  return users;
}

export function getUserRows(users = [], searchText = "", userType, userStatus) {
  const mappedUsers = mapUsersToRows(users);
  const searchFilteredUsers = filterUsersBySearch(mappedUsers, searchText);
  const statusFilteredUsers = filterUsersByStatus(searchFilteredUsers, userStatus);

  return filterUsersByType(statusFilteredUsers, userType);
}

export function getCreateTeamUserOptions(users = []) {
  return [...users]
    .filter((user) => user.active)
    .sort((leftUser, rightUser) =>
      leftUser.first_name.localeCompare(rightUser.first_name)
    )
    .map((user) => ({
      label: `${user.first_name} ${user.last_name}`,
      value: user.user_id,
    }));
}

export function getSortedTeams(teams = []) {
  return [...teams].sort((leftTeam, rightTeam) =>
    leftTeam?.team_name.localeCompare(rightTeam?.team_name)
  );
}

export function getActiveDialogContent(isActive) {
  return {
    title: isActive
      ? "Confirmation: Disable User"
      : "Confirmation: Enable User",
    message: isActive
      ? "Are you sure you want to Disable this user?"
      : "Are you sure you want to Enable this user?",
    buttonText: isActive ? "Disable" : "Enable",
  };
}

export function getAdminDialogContent(isSuperAdmin) {
  return {
    title: isSuperAdmin === "Super Admin"
      ? "Confirmation: Withdraw Admin Role"
      : "Confirmation: Grant Admin Role",
    message: isSuperAdmin === "Super Admin"
      ? "Are you sure you want to Withdraw Admin Role?"
      : "Are you sure you want to Grant Admin Role?",
    buttonText: isSuperAdmin === "Super Admin" ? "Withdraw" : "Grant",
  };
}

export function getLogsDialogContent(logRequired, status) {
  return {
    tooltipTitle: status
      ? "Disable Worklog Tracking"
      : "Enable Worklog Tracking",
    message: logRequired
      ? "Are you sure you want to disable the worklog status? Disabling it will stop tracking your current work activities."
      : "Are you sure you want to enable the worklog status?",
  };
}
